<template>
  <div :class="seriesProgressClasses">
    <button class="button basic" @click="onClickSeriesProgress">
      <svg class="circle" width="150" height="150" viewBox="0 0 150 150">
        <circle
          cx="75"
          cy="75"
          r="65"
          fill="none"
          stroke-width="8px"
          stroke-linecap="round"
          class="track"
        />
        <circle
          cx="75"
          cy="75"
          r="65"
          fill="none"
          :stroke="progressStroke"
          stroke-width="8px"
          stroke-linecap="round"
          stroke-dasharray="408.2"
          :stroke-dashoffset="strokeDashoffset"
          class="progress"
        />
        <defs>
          <linearGradient
            :id="linearGradientId"
            gradientTransform="rotate(90)"
            gradientUnits="userSpaceOnUse"
          >
            <stop
              v-for="(gradient, index) in series.gradient[0].stops"
              :key="index"
              :offset="gradient.colorStop"
              :stop-color="gradient.color"
            />
          </linearGradient>
        </defs>
      </svg>
      <div class="text">{{ progressText }}</div>
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SeriesProgress',

  /**
   * 属性
   */
  props: {
    series: Object,
    gradient: Object,
  },

  /**
   * 数据
   */
  data() {
    return {
      progress: 0,
      progressTextType: 'percent',
    };
  },

  /**
   * 监视
   */
  watch: {
    series(newValue, oldValue) {
      if (newValue) {
        this.progress = newValue.progress.percent;
      }
    },
  },

  /**
   * 计算属性
   */
  computed: {
    strokeDashoffset() {
      return `calc(408.2 - (408.2 * ${this.progress}) / 100)`;
    },

    progressText() {
      let progressText = '';

      if (this.progressTextType === 'percent') {
        progressText =
          this.series.progress && this.series.progress.percent
            ? `${this.series.progress.percent}%`
            : '0%';
      }

      if (this.progressTextType === 'completed') {
        progressText =
          this.series.progress && this.series.progress.completed
            ? `${this.series.progress.completed}节`
            : '0节';
      }

      return progressText;
    },

    seriesProgressClasses() {
      return ['series-progress', { disabled: !this.series.progress }];
    },

    linearGradientId() {
      return `linear-gradient-${this.series.id}`;
    },

    progressStroke() {
      return `url(#${this.linearGradientId})`;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 已挂载
   */
  mounted() {
    setTimeout(() => {
      this.progress = this.series.progress
        ? parseInt(this.series.progress.percent, 10)
        : 0;
    }, 200);
  },

  /**
   * 组件方法
   */
  methods: {
    onClickSeriesProgress() {
      if (this.progressTextType === 'percent') {
        this.progressTextType = 'completed';
      } else {
        this.progressTextType = 'percent';
      }
    },
  },

  /**
   * 使用组件
   */
  components: {},
});
</script>

<style scoped>
@import './styles/series-progress.css';
</style>
